import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import { formatPrice } from '../utils/formatPrice';
import ProductImage from './ProductImage';

/**
 * ProductCard - Картка продукту для каталогу
 * 
 * @param {Object} product - Об'єкт продукту
 * @param {Function} onProductClick - Callback при кліку на картку
 * @param {Function} onBuyClick - Callback при кліку на "Купити"
 */
const ProductCard = memo(({ product, onProductClick, onBuyClick }) => {
    const handleBuyClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onBuyClick(product, event);
    };

    return (
        <div className="product-card">
            <Link
                to={`/products/${product.slug || product.id}`}
                className="product-card-inner-link"
                aria-label={`Переглянути ${product.name_ua || 'товар'}`}
            >
                <div className="product-top">
                    <div className="product-image-container">
                        <ProductImage
                            src={product.photo}
                            alt={`${product.name_ua}${product.numerkatalogowy ? ` (${product.numerkatalogowy})` : ''}`}
                            className="product-image"
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                    <h2 className="product-name" title={product.name_ua}>
                        {product.name_ua}
                    </h2>
                </div>
            </Link>
            <div className="product-bottom">
                {product.price && (
                    <div className="product-price-small" aria-label={`Ціна: ${product.price} гривень`}>
                        {formatPrice(product.price)} ₴
                    </div>
                )}
                <button
                    className="buy-button-small"
                    onClick={handleBuyClick}
                    type="button"
                    aria-label={`Додати до кошика: ${product.name_ua}`}
                >
                    <FaShoppingCart className="buy-button-icon" />
                    <span>Купити</span>
                </button>
            </div>
        </div>
    );
});

ProductCard.displayName = 'ProductCard';

ProductCard.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name_ua: PropTypes.string,
        photo: PropTypes.string,
        price: PropTypes.number,
        code1: PropTypes.string,
        numerkatalogowy: PropTypes.string,
        inStock: PropTypes.bool,
    }).isRequired,
    onProductClick: PropTypes.func.isRequired,
    onBuyClick: PropTypes.func.isRequired,
};

export default ProductCard;
